export default "/images/menu.svg?644fa295fdd5f662e642ba6bfb084239";